import { EARTH_RADIUS_IN_KM } from "./calculateDistanceInKmBetweenCoordinates.const";
import { Position } from "geojson";

export function calculateDistanceInKmBetweenCoordinates(
  [longitude1, latitude1]: [number, number],
  [longitude2, latitude2]: [number, number]
) {
  const latitudeDistanceInDegrees = degreesToRadians(latitude2 - latitude1);
  const longitudeDistanceInDegrees = degreesToRadians(longitude2 - longitude1);

  latitude1 = degreesToRadians(latitude1);
  latitude2 = degreesToRadians(latitude2);

  const angle =
    Math.sin(latitudeDistanceInDegrees / 2) *
      Math.sin(latitudeDistanceInDegrees / 2) +
    Math.sin(longitudeDistanceInDegrees / 2) *
      Math.sin(longitudeDistanceInDegrees / 2) *
      Math.cos(latitude1) *
      Math.cos(latitude2);

  const chord = 2 * Math.atan2(Math.sqrt(angle), Math.sqrt(1 - angle));

  return EARTH_RADIUS_IN_KM * chord;
}

export async function getDistanceBetweenCoordinatesWithPathAsync(
  [longitude1, latitude1]: [number, number],
  [longitude2, latitude2]: [number, number]
): Promise<[number, Position[] | null]> {
  try {
    const data = await fetch(
      `https://api.mapbox.com/directions/v5/mapbox/walking/${longitude1},${latitude1};${longitude2},${latitude2}?access_token=${process.env.NEXT_PUBLIC_MAXBOX_TOKEN || "pk.eyJ1IjoiLWthdHJpbmU4NiIsImEiOiJjbHhuM2o2Z3QwZW9tMnJzZXdyZ3d6bjVkIn0.myE9RFFZikeU-1cB0Hb69w"}&geometries=geojson`
    );
    const json = await data.json();
    const distance_data = json.routes[0].distance / 1000;
    const coordinates = json.routes[0].geometry.coordinates as Position[];
    return [distance_data, coordinates];
  } catch {
    const distance_value = calculateDistanceInKmBetweenCoordinates(
      [longitude1, latitude1],
      [longitude2, latitude2]
    );
    return [distance_value, null];
  }
}

function degreesToRadians(degrees: number) {
  return (degrees * Math.PI) / 180;
}
